// extracted by mini-css-extract-plugin
export default {"menu-item":"AppMenu_menu-item__OCZ6X","menuItem":"AppMenu_menu-item__OCZ6X","deleteItem":"AppMenu_deleteItem__94IyA","list":"AppMenu_list__akopv","paper":"AppMenu_paper__Ko6jt"};